import React from 'react';
import { Divider, Section, SectionSubTitle, Typography } from 'common/components';
import { ProductCollapse } from 'common/components/pdp';
import { createElementKey } from 'utils';
import { analyticsUtils } from 'utils/analytics-utils';
import { METAL_ROOF_CHARACTERISTICS_MAP } from './metal-roof-characteristics-constants';
import {
  metalRoofCharasteristicsCollapse,
  metalRoofCharasteristicsColumn,
  metalRoofCharasteristicsRow,
  metalRoofCharasteristicsRowWrapper,
  metalRoofCharasteristicsShowMoreBtn,
} from './metal-roof-characteristics-styles';

type MetalRoofCharacteristicsProps = {
  elementBlock: string;
  roofType: string;
};

export const MetalRoofCharacteristics: React.FC<MetalRoofCharacteristicsProps> = ({
  elementBlock,
  roofType,
}) => {
  const characteristicList = METAL_ROOF_CHARACTERISTICS_MAP[roofType];
  const length = characteristicList.length - 1;

  const handleOnShowMoreClick = () => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock,
      elementName: 'Характеристики',
    });
  };

  return (
    <Section>
      <SectionSubTitle margin="m">Характеристики</SectionSubTitle>
      <ProductCollapse
        elementName="Характеристики"
        onShowMoreClick={handleOnShowMoreClick}
        showMoreBtnClassName={metalRoofCharasteristicsShowMoreBtn}>
        <div className={metalRoofCharasteristicsCollapse}>
          {characteristicList.map(({ name, value }, index) => (
            <div
              className={metalRoofCharasteristicsRowWrapper}
              key={createElementKey('characteristic', index)}>
              <div className={metalRoofCharasteristicsRow}>
                <div className={metalRoofCharasteristicsColumn}>
                  <Typography variant="m" size="body_accent">
                    {name}
                  </Typography>
                </div>
                <div className={metalRoofCharasteristicsColumn}>
                  <Typography variant="m" size="body_long">
                    {value}
                  </Typography>
                </div>
              </div>

              {index < length && <Divider />}
            </div>
          ))}
        </div>
      </ProductCollapse>
    </Section>
  );
};
